import { createApp } from 'vue';
import router from '@/router';
import { createPinia } from 'pinia';
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify';
import vuetify from '@/plugins/vuetify';
import DelayedToastPlugin from '@/plugins/toastDelayedPlugin';
import { i18n } from '@/plugins/i18n';
import App from '@/App.vue';

import '@mdi/font/css/materialdesignicons.css';
import 'vue3-toastify/dist/index.css';

const app = createApp(App);
app.use(router);
app.use(createPinia());
app.use(vuetify);
app.use(i18n);
app.use(Vue3Toastify, {
	autoClose: 3000,
	position: 'top-right',
} as ToastContainerOptions);
app.use(DelayedToastPlugin);

const beforeAppMountActions = async () => {
	const locale: string = 'pl';
	
	window.t = i18n.global.t;
	
	// @ts-ignore
	i18n.global.locale.value = locale;
};

beforeAppMountActions().then(() => {
	app.mount('#app');
});
